module.exports = __webpack_public_path__ + "img/Klaudia_K.16669a02.jpg";